import * as React from "react";
function Announcement02Icon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M4 14l1.575 6.299c.044.177.066.265.092.343A2 2 0 007.4 21.992c.08.007.172.007.355.007.228 0 .343 0 .44-.01a2 2 0 001.797-1.797c.009-.096.009-.21.009-.44V5.5m8.5 8a3.5 3.5 0 100-7m-8.25-1H6.5a4.5 4.5 0 000 9h3.75c1.766 0 3.927.947 5.594 1.856.973.53 1.46.795 1.778.756a.946.946 0 00.691-.411c.187-.26.187-.783.187-1.827V5.126c0-1.044 0-1.566-.187-1.827a.946.946 0 00-.691-.411c-.319-.039-.805.226-1.778.756-1.667.909-3.828 1.856-5.594 1.856z"
  }));
}
const ForwardRef = React.forwardRef(Announcement02Icon);
export default ForwardRef;